<template>
  <div class="hearing-test-title mt-3">
    <h3 class="d-flex justify-content-center header">
      {{ currentPageHeader }}
    </h3>
  </div>
</template>
<script>
export default {
  props: {
    currentStage: {
      type: Number,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    currentPageHeader: function () {
      if (this.currentStage === 5) {
        return this.$t('form.header')
      } else if (this.currentStage === 6) {
        return this.$t('submit_header')
      } else {
        return this.$t('header')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.text-evollu {
  color: #29c4a9;
}
</style>